(function () {
  var handle = 'beginner-sunflower-phone-bag-crochet-kit';
  if (window.__codexSunflowerPhoneBagGalleryFix) return;
  window.__codexSunflowerPhoneBagGalleryFix = true;

  function isTarget() {
    return window.location.pathname.indexOf('/products/' + handle) !== -1 ||
      ((window.MinimogSettings || {}).productHandle === handle);
  }

  if (!isTarget()) return;

  var css = '.codex-sunflower-hidden{display:none!important}';
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  var productPromise = fetch('/products/' + handle + '.js?codex_variant_media=' + Date.now(), {
    credentials: 'same-origin',
    cache: 'no-store'
  }).then(function (response) {
    return response.json();
  }).catch(function () {
    return null;
  });

  function groupFromText(value) {
    value = String(value || '').toLowerCase();
    return value.indexOf('purple') !== -1 ? 'purple' : 'cream';
  }

  function currentGroup() {
    var checked = document.querySelector('variant-picker input.m-product-option__input:checked, variant-picker input[name^="options"]:checked');
    if (checked) return groupFromText(checked.value);

    var selectedNode = document.querySelector('variant-picker .option-label--selected, variant-picker .m-product-option--label .selected-value');
    if (selectedNode) return groupFromText(selectedNode.textContent);

    var select = document.querySelector('variant-picker select, select[name^="options"]');
    if (select) return groupFromText(select.value || (select.options[select.selectedIndex] && select.options[select.selectedIndex].text));

    var variantInput = document.querySelector('form[action*="/cart/add"] [name="id"], .m-product-form [name="id"]');
    if (variantInput) {
      if (String(variantInput.value) === '45204545306694') return 'purple';
      if (String(variantInput.value) === '45204545273926') return 'cream';
    }

    try {
      var variant = new URLSearchParams(window.location.search).get('variant');
      if (variant === '45204545306694') return 'purple';
    } catch (error) {}
    return 'cream';
  }

  function mediaGroup(media) {
    var alt = String(media.alt || '').toLowerCase();
    if (alt.indexOf('variant:purple') !== -1) return 'purple';
    if (alt.indexOf('variant:cream') !== -1) return 'cream';
    var src = String(media.src || '').toLowerCase();
    if (src.indexOf('purple-sunflower-phone-bag') !== -1) return 'purple';
    if (src.indexOf('cream-sunflower-phone-bag') !== -1) return 'cream';
    return 'common';
  }

  function mediaForGroup(product, group) {
    var list = product && Array.isArray(product.media) ? product.media : [];
    return list.filter(function (media) {
      return media.media_type === 'image' && mediaGroup(media) === group;
    }).slice(0, 5);
  }

  function withWidth(url, width) {
    if (!url) return '';
    var clean = String(url).replace(/^\/\//, 'https://');
    return clean + (clean.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function srcset(url, widths) {
    return widths.map(function (width) {
      return withWidth(url, width) + ' ' + width + 'w';
    }).join(', ');
  }

  function updateOne(mediaNode, media, isThumb) {
    var item = mediaNode.closest('.swiper-slide, .m-product-media--item') || mediaNode;
    if (!media) {
      item.classList.add('codex-sunflower-hidden');
      mediaNode.classList.add('codex-sunflower-hidden');
      return;
    }

    item.classList.remove('codex-sunflower-hidden');
    mediaNode.classList.remove('codex-sunflower-hidden');
    item.setAttribute('data-media-id', media.id);
    mediaNode.setAttribute('data-media-id', media.id);
    mediaNode.setAttribute('data-media-alt', media.alt || '');
    mediaNode.setAttribute('data-media-src', withWidth(media.src, isThumb ? 400 : 1946));

    var img = mediaNode.querySelector('img');
    if (!img) return;
    var widths = isThumb ? [70, 100, 140, 150, 200, 300, 400] : [400, 620, 690, 810, 980, 1240, 1380, 1620, 1946];
    img.alt = media.alt || '';
    img.src = withWidth(media.src, isThumb ? 400 : 1200);
    img.srcset = srcset(media.src, widths);
    img.removeAttribute('data-src');
    img.removeAttribute('data-srcset');
  }

  function updateSwiper(root) {
    Array.prototype.slice.call(root.querySelectorAll('.swiper-container, .nav-swiper-container')).forEach(function (container) {
      var swiper = container.swiper;
      if (!swiper) return;
      try {
        swiper.slideTo(0, 0);
        swiper.update();
      } catch (error) {}
    });
  }

  function apply(product) {
    if (!product) return;
    var group = currentGroup();
    var media = mediaForGroup(product, group);
    if (media.length < 5) return;

    var main = Array.prototype.slice.call(document.querySelectorAll('.m-product-media--slider__images .m-product-media'));
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('.m-product-media--slider__thumbnails .m-product-media'));

    main.forEach(function (node, index) {
      updateOne(node, media[index], false);
    });
    thumbs.forEach(function (node, index) {
      updateOne(node, media[index], true);
    });

    var selectedVariant = product.variants && product.variants.find(function (variant) {
      return groupFromText(variant.title) === group;
    });
    if (selectedVariant) {
      Array.prototype.slice.call(document.querySelectorAll('form[action*="/cart/add"] [name="id"], .m-product-form [name="id"]')).forEach(function (input) {
        input.value = selectedVariant.id;
      });
    }

    updateSwiper(document);
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.setTimeout(function () {
      scheduled = false;
      productPromise.then(apply);
    }, 120);
  }

  document.addEventListener('change', schedule, true);
  document.addEventListener('click', schedule, true);
  document.addEventListener('variant:change', schedule);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('DOMContentLoaded', schedule);
  window.addEventListener('load', schedule);

  if (window.MutationObserver) {
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  }

  schedule();
})();
/* Codex penguin gallery override 2026-06-23 */
(function(){
  var handle='beginner-penguin-crochet-kit';
  if(location.pathname.indexOf('/products/'+handle)===-1)return;
  var userBrowsingUntil=0;
  function inGallery(el){return !!(el&&el.closest&&el.closest('.m-product-media,.m-product-media--item,.m-product-media__nav,.swiper-thumbs,.m-product-media__slider,.m-product-media__thumbnails,.product__media-list,.product__media-item')) && !(el.closest('variant-picker,.m-product-option,.m-product-option--node,[data-option-position],[data-option-value]'));}
  document.addEventListener('click',function(e){if(inGallery(e.target))userBrowsingUntil=Date.now()+4500;},true);
  document.addEventListener('touchstart',function(e){if(inGallery(e.target))userBrowsingUntil=Date.now()+4500;},true);
  function patchSwiper(sw){
    if(!sw||sw.__codexPenguinPatched||typeof sw.slideTo!=='function')return;
    var original=sw.slideTo;
    sw.__codexPenguinPatched=true;
    sw.slideTo=function(index,speed){
      if(Date.now()<userBrowsingUntil && speed===0){try{if(typeof sw.update==='function')sw.update();}catch(e){} return sw;}
      return original.apply(this,arguments);
    };
  }
  function patchAll(){document.querySelectorAll('.swiper-container,.swiper').forEach(function(el){if(el.swiper)patchSwiper(el.swiper);});}
  patchAll();setInterval(patchAll,500);
})();
